import { useQuery } from '@tanstack/react-query';
import { getContests } from '@/shared/api/contest/getContests';
import { TContestStatus } from '@/shared/api/contest/getContests/types';

type Params = Parameters<typeof getContests>[0];

interface Options {
  status?: TContestStatus[];
}

export const useGetContests = (params: Params, options?: Options) => {
  return useQuery({
    queryKey: getUseGetContestsQueryKey(params),
    queryFn: () => getContests(params),
    select: (data) => {
      if (!options?.status?.length) return data;
      return data.filter((i) => options.status!.includes(i.acf.status));
    },
  });
};

export const getUseGetContestsQueryKey = (params: Params) => [
  'getContests',
  params,
];
